export const organizationRoutes = {
  login: '/login',
  dashboard: '/',
  memberstable: '/members',
  contracts: '/contracts',
  onboarding: '/onboarding',
  forgotpassword: '/forgotpassword',
  resetpassword: '/resetpassword',
};
